import { auth, firestore } from "../config/firebase";
var uuid = require("uuid");
// USERS
export const getUsers = async () => {
  try {
    let users = [];
    const snapshot = await firestore.collection("users").get();
    snapshot.forEach(function (doc) {
      let user = doc.data();
      users.push({
        id: doc.id,
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
        bio: user.bio,
        phone: user.phone,
        addresses: user.addresses,
        memberships: user.memberships,
        user_types: user.user_types,
        note: user.note,
      });
    });
    return users;
  } catch (e) {
    return console.log(e);
  }
};

export const getUser = async (id) => {
  try {
    const user = await firestore.collection("users").doc(id).get();
    let data = {
      id: id,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      bio: user.bio,
      phone: user.phone,
      addresses: user.addresses,
      memberships: user.memberships,
      user_types: user.user_types,
      note: user.note,
    };
    return data;
  } catch (e) {
    return console.log(e);
  }
};

export const getUserByFirebaseId = async (uid) => {
  try {
    if (!uid.uid) {
      return null;
    }
    const query = await firestore
      .collection("users")
      .where("uid", "==", uid.uid)
      .get();
    if (!query.docs.length) {
      return null;
    }
    let user = query.docs[0].data();
    let data = {
      id: uid,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      bio: user.bio,
      phone: user.phone,
      addresses: user.addresses,
      memberships: user.memberships,
      user_types: user.user_types,
      note: user.note,
    };
    return data;
  } catch (e) {
    return console.log(e);
  }
};

export const registerAccount = async (data) => {
  try {
    auth
      .createUserWithEmailAndPassword(data.email, uuid.v4())
      .then(async (res) => {
        firestore
          .collection("users")
          .doc(res.user.uid)
          .set({
            uid: res.user.uid,
            timestamp: new Date(),
            ...data,
          });
        return auth
          .sendPasswordResetEmail(data.email)
          .then(function () {
            console.log(`email password reset to ${data.email}`);
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch((error) => {
        return console.log(error);
      });
  } catch (e) {
    return console.log(e);
  }
};
